import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class Transactions extends React.Component {
    constructor(props) {
        super(props);
        this.onfromDateChanged = this.onfromDateChanged.bind(this);
        this.ontoDateChanged = this.ontoDateChanged.bind(this);
        this.onsearch = this.onsearch.bind(this);
        this.state = {
            isCompanyWallet: true,
            titleText: "Activation Wallet Transfer",
            fromDate: "",
            toDate: ""
        }
    }
    onfromDateChanged(event) {
        this.setState({ fromDate: event.target.value });
    }
    ontoDateChanged(event) {
        this.setState({ toDate: event.target.value });
    }
    onsearch() {
        let json = {
            fromdate: this.state.fromDate,
            todate: this.state.toDate
        }
        this.getTransactionHistory(JSON.stringify(json));
    }
    componentDidMount() {
        this.setState({
            isCompanyWallet: this.props.history.params.type !== "cash",
            titleText: this.props.history.params.type !== "cash" ? "Activation Wallet Transactions" : "Payout Wallet Transactions"
        });
        this.getTransactionHistory();
    }
    async getTransactionHistory(dates) {
        this.setState({ directSponsorsTable: "" });
        let url = this.props.history.params.type !== "cash" ? "GetCompanyWallet.asp" : "GetCashWallet.asp";
        let res = await GetORPostAsync(url, "POST", dates, localStorage.getItem("token"));
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                toast(res.message);
                this.props.history.push({
                    pathname: "/"
                });
            }
            this.setState({ directSponsorsTable: "<tr><td colSpan='6'>No Records</td></tr>" });
            return;
        }
        let str = "";
        for (let i = 0; i < res.items.length; i++) {
            str += '<tr><td class="bg-color-1 text-white">' + (i + 1) + '</td><td>' + res.items[i].date + '</td><td>' + res.items[i].Description + '</td><td>' + res.items[i].Credit + '</td><td>' + res.items[i].Debit + '</td><td>' + res.items[i].Balance + '</td></tr>';
            if (i === res.items.length - 1) {
                this.setState({ directSponsorsTable: str });
            }
        }
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>{this.state.titleText}</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 row">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>{this.state.titleText}</h3>
                        </div>
                        <div className="d-md-flex mt-4 mb-2">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="date" className="form-control daterange-single" id="start_date" name="start_date" placeholder="From Date" autoComplete="off" onChange={this.onfromDateChanged} value={this.state.fromDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="date" className="form-control daterange-single" id="end_date" name="end_date" placeholder="To Date" autoComplete="off" onChange={this.ontoDateChanged} value={this.state.toDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 text-left">
                                <div className="form-group">
                                    <button type="button" className="btn bg-color-1" style={{ color: "white" }} onClick={this.onsearch}> Search </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table style={{ textAlign: "center" }} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Credit</th>
                                            <th>Debit</th>
                                            <th>Available Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{ __html: this.state.directSponsorsTable }}>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(Transactions);